import { Divider, Form, Input, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import ModalComponent from '../../../components/ModalComponent';
import SelectComponent from '../../../components/SelectComponent';

const { Item } = Form;
const { Text } = Typography;

const EditMediaModal = ({
  isModalOpen,
  setIsModalOpen,
  mediaData,
  onFinish,
  isBtnLoading,
  typeOptions,
  getSubtypeOptions,
  isOptionsLoading,
}) => {
  const [form] = Form.useForm();
  const [selectedType, setSelectedType] = useState(null);

  const subtypeOptions = getSubtypeOptions(selectedType);

  useEffect(() => {
    if (isModalOpen && mediaData) {
      setSelectedType(mediaData?.type);
      form?.setFieldsValue({
        name: mediaData?.name,
        type: mediaData?.type,
        subtype: mediaData?.subtype || undefined,
      });
    }
  }, [isModalOpen, mediaData]);

  const handleTypeChange = (value) => {
    setSelectedType(value);
    form?.setFieldValue('subtype', undefined);
  };

  return (
    <ModalComponent
      open={isModalOpen}
      title="Edit Media"
      okText="Save"
      onOk={form?.submit}
      onCancel={() => !isBtnLoading && setIsModalOpen(false)}
      confirmLoading={isBtnLoading}
      cancelButtonProps={{ disabled: isBtnLoading }}
      closable={!isBtnLoading}
      keyboard={false}
      destroyOnClose
      forceRender
    >
      <Divider />
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
        disabled={isBtnLoading}
      >
        <Item
          label="Name"
          name="name"
          rules={[{ required: true, message: 'Please enter a name!' }]}
        >
          <Input allowClear placeholder="Enter a name for this media" />
        </Item>
        <Item
          label="Type"
          name="type"
          rules={[{ required: true, message: 'Please select a type!' }]}
        >
          <SelectComponent
            optionFilterProp="label"
            placeholder="Select type"
            options={typeOptions}
            loading={isOptionsLoading}
            onChange={handleTypeChange}
          />
        </Item>
        <Item label="Subtype" name="subtype">
          <SelectComponent
            optionFilterProp="label"
            placeholder={
              selectedType ? 'Select subtype' : 'Select a type first'
            }
            options={subtypeOptions}
            disabled={isBtnLoading || !selectedType}
          />
        </Item>
      </Form>
      <Text type="secondary">
        The file itself cannot be replaced. Upload a new media entry instead.
      </Text>
    </ModalComponent>
  );
};

export default EditMediaModal;
